import { createRouter, createWebHistory } from 'vue-router'




const routes = [
  
  {
    path: '/', //带参数，在params.period时可以获取
    
    name: '/',
    component: () => import( '@/views/index.vue'),
    
  },
  
  
]
//  
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),

  routes
})

export default router
